import { useState } from 'react';
import { SocialButton } from '@fpsm/cxy-components/SocialButton';
import { Form } from '@remix-run/react';

import { type View, VIEW_SIGNUP } from '~/apps/product-plus/providers/auth-modal-provider';
import { useRepubContext } from '~/providers/repub-context';
import { type OAuth2Provider, providers } from '~/templates/auth/types';
import { trackEvent } from '~/utils/dataLayer';

import { actions, events, views } from '../../types';

import styles from './styles/SocialButtons.module.css';

export type SocialButtonsProps = {currentUrl: string;facebookID: string;googleID: string;view: View;};

export const SocialButtons = ({ currentUrl, facebookID, googleID, view }: SocialButtonsProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const { repubPath } = useRepubContext();

  const renderFormWithSocialButton = (provider: OAuth2Provider) => {
    if (provider === providers.FACEBOOK && !facebookID) return null;
    if (provider === providers.GOOGLE && !googleID) return null;

    const action = `${repubPath}/plus/auth/${provider}`;

    const inputView = view === VIEW_SIGNUP ? views.SIGN_UP : views.LOGIN;

    return (
      <Form
        action={action}
        method="post"
        onSubmit={() => {
          setIsLoading(true);
          trackEvent(events.SOCIAL_ATTEMPT, {
            eventAction: actions.SOCIAL_AUTH,
            method: provider,
            view: inputView
          });
        }}>

        <input key="returnTo" name="returnTo" type="hidden" value={currentUrl} />
        <input key="view" name="view" type="hidden" value={inputView} />
        <SocialButton className={styles.socialButton} isLoading={isLoading} variant={provider} />
      </Form>);

  };

  return (
    <div data-testid="social-buttons">
      {renderFormWithSocialButton(providers.FACEBOOK)}
      {renderFormWithSocialButton(providers.GOOGLE)}
    </div>);

};

SocialButtons.displayName = 'SocialButtons';